<template>
<div id="app">
    <Header> </Header>
    <router-link to="/"></router-link>
    <router-link to="/artical"></router-link>
    <router-link to="/About"></router-link>
  <router-view/>
  <Footer class="footer bg-primary text-center text-white"> </Footer>
</div>
</template>



<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components:{
    Header,
    Footer
  },
  metaInfo: {
    link: 
    [
      {
        rel: "stylesheet",
        href: "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
      },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css?family=Muli:200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap"
      },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css?family=Roboto+Slab:100,200,300,400,500,600,700,800,900&display=swap"
      },
    ]
  }
}
</script>
